import request from '@/utils/request/request'

export function exam_lists(data) {
  return request({
    url: '/v1/exam_lists',
    method: 'get',
    data
  })
}

export function getExam(data) {
  return request({
    url: '/v1/exam',
    method: 'get',
    data
  })
}
export function exam_record(data) {
  return request({
    url: '/v1/exam_record',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/exam.js